/* GoldSupply - the ribbon artwork.

   ONE definition of the piece, used by the homepage hero and by the hero at the
   top of every inner page. Do not copy this formula into a section or snippet;
   point another [data-gs-art] host at this file instead.

   WHY THIS IS A FORMULA AND NOT AN IMAGE FILE
   The piece is a ribbon twisting about its own centreline. A point at offset u
   across the ribbon projects to  c(s) + u.H(s).cos(th(s)) . n(s).  Where cos(th)
   passes through zero the ribbon is edge-on and every strand collapses onto the
   centreline - that pinch is what makes it read as three-dimensional with no
   shading, gradient mesh or highlight anywhere in it.

   At the density that makes it look like silk rather than a diagram it is ~165
   KB as an SVG file. The formula that produces it is about 2 KB, so the page
   carries the formula and draws it on arrival. Changing the look means changing
   a constant here - there is nothing to re-export and no asset to keep in sync.

   Composition: the left ~26% of the canvas is masked clear so the headline sits
   on plain white, and the form develops across the right. Keep that mask if the
   copy stays left-aligned.

   HOW A PAGE GETS ITS OWN VERSION
   The host element carries data-gs-art="<name>" and that name picks the
   variation - see variant() below. Every host on the page is drawn, so a page
   may carry more than one. */
(function () {
  var hosts = document.querySelectorAll('[data-gs-art]');
  if (!hosts.length) { return; }

  var W = 1600, H = 760;
  function r(n) { return Math.round(n * 10) / 10; }

  /* ---------- the variations ----------
     A variation only MOVES the ribbon. dp slides the waves along their length,
     which moves where the ribbon turns edge-on; dth rotates the twist, which
     changes how many of those pinches fall inside the frame; dcy raises or
     lowers the centreline. Nothing here touches the palette, the strand count,
     the line weights or the mask - so every page reads as the same hand.

     THE NAME IS HASHED RATHER THAN LOOKED UP IN A TABLE, so a page added next
     year gets its own version with nothing to wire up, and a given page always
     draws the same curve rather than a new one on each load. FNV-1a is used
     because it only has to be stable and well spread, not cryptographic.

     'home' IS EXACTLY ZERO on every axis, and the offsets below are ADDED to
     the published constants rather than replacing them - so the homepage keeps
     the curve it shipped with, to the last decimal, rather than a near-miss. */
  function variant(name) {
    if (!name || name === 'home') { return { dp: 0, dth: 0, dcy: 0 }; }
    var h = 2166136261, i;
    for (i = 0; i < name.length; i++) {
      h ^= name.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return {
      dp:  ((h >>> 0)  % 997) / 997 * Math.PI * 2,
      dth: ((h >>> 10) % 991) / 991 * 1.5 - 0.75,
      dcy: ((h >>> 20) % 983) / 983 * 76 - 38
    };
  }

  function ribbon(o, v) {
    var out = [], i, k, a;
    for (i = 0; i < o.n; i++) {
      var vv = (i / (o.n - 1)) * 2 - 1;
      var u = Math.sin(vv * Math.PI / 2);      /* cluster strands at the edges */
      var pts = [];
      for (k = 0; k <= o.steps; k++) {
        var s = k / o.steps;
        var x = o.x0 + (o.x1 - o.x0) * s;
        var y = o.cy + v.dcy, y2 = o.cy + v.dcy, ds = 1e-3;
        for (a = 0; a < o.amps.length; a++) {
          y  += o.amps[a].A * Math.sin(2 * Math.PI * o.amps[a].f * s + o.amps[a].p + v.dp);
          y2 += o.amps[a].A * Math.sin(2 * Math.PI * o.amps[a].f * (s + ds) + o.amps[a].p + v.dp);
        }
        var dx = (o.x1 - o.x0) * ds, dy = y2 - y, L = Math.sqrt(dx * dx + dy * dy);
        var nx = -dy / L, ny = dx / L;
        var Hs = o.H0 * (1 + o.Hvar * Math.sin(Math.PI * s));
        var th = o.th0 + v.dth + o.th1 * s;
        var across = u * Hs * Math.cos(th);
        var depth  = u * Hs * Math.sin(th);
        var sc = 1 + depth * o.persp;
        pts.push(r(x + nx * across * sc + depth * o.skew) + ' ' + r(y + ny * across * sc));
      }
      out.push({ u: u, d: 'M' + pts.join('L') });
    }
    return out;
  }

  function draw(name) {
    var v = variant(name);
    var groups = [
      /* far pass - crosses behind the main ribbon so it has something to pass
         in front of. Faint on purpose: this is depth, not a second subject. */
      { opacity: 0.22, w: 1.0, strands: ribbon({
          x0: 60, x1: 1760, cy: 470, H0: 150, Hvar: 0.6,
          amps: [{ A: 120, f: 0.58, p: 2.2 }, { A: 34, f: 1.45, p: 0.9 }],
          th0: -0.7, th1: 3.6, n: 110, steps: 34, persp: 0.0009, skew: 0.30 }, v) },
      /* the main ribbon */
      { opacity: 0.72, w: 1.25, strands: ribbon({
          x0: -120, x1: 1800, cy: 400, H0: 290, Hvar: 0.5,
          amps: [{ A: 196, f: 0.66, p: 3.45 }, { A: 54, f: 1.8, p: 1.85 }],
          th0: 0.3, th1: 3.2, n: 230, steps: 38, persp: 0.0014, skew: 0.48 }, v) }
    ];

    var body = '', g, i, st;
    for (g = 0; g < groups.length; g++) {
      body += '<g stroke="url(#gsInk)" fill="none" stroke-linecap="round" opacity="' + groups[g].opacity + '">';
      for (i = 0; i < groups[g].strands.length; i++) {
        st = groups[g].strands[i];
        /* Strands down the middle of the band catch the light; the outer edges
           fall away. This is what gives the ribbon a lit face without shading. */
        var core = 1 - Math.abs(st.u);
        var fade = 0.3 + 0.7 * Math.pow(core, 0.55);
        var wid = groups[g].w * (0.7 + 0.5 * core);
        body += '<path d="' + st.d + '" stroke-width="' + (Math.round(wid * 100) / 100) +
                '" opacity="' + (Math.round(fade * 100) / 100) + '"/>';
      }
      body += '</g>';
    }

    /* The gradient ids are shared between hosts on purpose: two heroes on one
       page should be inked from the same ramp, and duplicate ids resolve to the
       first, which is identical. */
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="xMidYMid slice" aria-hidden="true" focusable="false">' +
      '<defs><linearGradient id="gsInk" gradientUnits="userSpaceOnUse" x1="120" y1="80" x2="1500" y2="640">' +
      '<stop offset="0" stop-color="#F0E4C4"/><stop offset=".28" stop-color="#D8BE72"/>' +
      '<stop offset=".58" stop-color="#B07D10"/><stop offset=".82" stop-color="#8E630C"/>' +
      '<stop offset="1" stop-color="#6E4C08"/></linearGradient>' +
      /* Clear on the left for the headline; dissolved on the right so the ribbon
         fades out instead of being chopped off at the container edge. */
      '<linearGradient id="gsFade" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#000"/><stop offset=".26" stop-color="#000"/>' +
      '<stop offset=".56" stop-color="#fff"/><stop offset=".88" stop-color="#fff"/>' +
      '<stop offset="1" stop-color="#1a1a1a"/></linearGradient>' +
      '<mask id="gsQuiet"><rect width="' + W + '" height="' + H + '" fill="url(#gsFade)"/></mask></defs>' +
      '<g mask="url(#gsQuiet)">' + body + '</g></svg>';
  }

  Array.prototype.forEach.call(hosts, function (host) {
    host.innerHTML = draw(host.getAttribute('data-gs-art'));
  });
}());
